import { useEventCallback } from '@mui/material/utils';

import { useDialogs } from '@work4all/components';
import {
  OpenEmailMaskControllerContext,
  OpenEmailMaskControllerProps,
} from '@work4all/components/lib/hooks/contact-email-mask/OpenEmailMaskControllerContext';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { sdObjTypeToEntity, typeNameToEntity } from '@work4all/utils';

import { MaskDialogOverlay } from '../../../../components/entity-picker/MaskDialogOverlay';

interface OpenEmailMaskControllerProviderProps {
  children: React.ReactNode;
}

export const OpenEmailMaskControllerProvider = ({
  children,
}: OpenEmailMaskControllerProviderProps) => {
  const dialogs = useDialogs();

  const openEmailMaskController = useEventCallback(
    (contactEmailData: OpenEmailMaskControllerProps) => {
      if (!contactEmailData) return;

      const { businessPartner, contactId, email, project, entityType } =
        contactEmailData;

      const businessPartnerType = sdObjTypeToEntity(
        businessPartner?.businessPartnerType
      );
      const entity =
        businessPartnerType ??
        entityType ??
        typeNameToEntity(businessPartner?.__typename);

      const entityTemplate = businessPartner?.id
        ? {
            entity: contactId ? Entities.contact : entity,
            ids: [
              contactId
                ? `${contactId}:${businessPartnerType}:${businessPartner?.id}`
                : businessPartner?.id,
            ],
          }
        : entityType === Entities.user
        ? {
            entity: entityType,
            ids: [contactId],
          }
        : undefined;

      const dialog = dialogs.open(MaskDialogOverlay, {
        entity: Entities.eMail,
        id: null,
        template: entityTemplate,
        onAfterSave: closeMaskOverlay,
        params: {
          overrideRecipients: email,
          processedMailTemplateArgs: JSON.stringify({
            noDirectContact: !contactId,
            project,
          }),
        },
        close() {
          dialogs.close(dialog.id);
        },
      });

      function closeMaskOverlay() {
        dialogs.close(dialog.id);
      }
    }
  );

  return (
    <OpenEmailMaskControllerContext.Provider value={openEmailMaskController}>
      {children}
    </OpenEmailMaskControllerContext.Provider>
  );
};
